<template>
  <transition name="slide-down">
    <div v-if="show" class="error-toast">
      <div class="error-content">
        <v-icon color="white" class="mr-2">mdi-alert-circle</v-icon>
        <span>{{ message }}</span>
      </div>
      <v-progress-linear :value="progress" height="4" color="white" class="toast-progress" />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ErrorToast',
  props: {
    show: { type: Boolean, required: true },
    message: { type: String, default: '' },
    progress: { type: Number, default: 100 },
  },
};
</script>

<style scoped>
.error-toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: #f46523;
  color: white;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  width: 90%;
  max-width: 500px;
}
.error-content {
  display: flex;
  align-items: center;
  font-weight: 600;
}
.toast-progress {
  margin-top: 8px;
  border-radius: 2px;
}
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.5s ease;
}
.slide-down-enter {
  transform: translate(-50%, -100%);
  opacity: 0;
}
.slide-down-leave-to {
  transform: translate(-50%, -100%);
  opacity: 0;
}
</style>
